var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 0a1 1 0 0 1 .993.883L11 1v1.314a7.754 7.754 0 0 1 6.686 6.687L19 9a1 1 0 0 1 .117 1.993L19 11h-1.314A7.754 7.754 0 0 1 11 17.686V19a1 1 0 0 1-1.993.117L9 19v-1.314A7.754 7.754 0 0 1 2.315 11H1a1 1 0 0 1-.117-1.993L1 9h1.314A7.754 7.754 0 0 1 9 2.315V1a1 1 0 0 1 1-1Zm0 4.25a5.75 5.75 0 1 0 0 11.5 5.75 5.75 0 0 0 0-11.5ZM10 6a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z",
  fill: "#FA541C"
})));
export default SvgLocation;